import format from 'date-fns/format';
import getYear from 'date-fns/getYear';
import startOfToday from 'date-fns/startOfToday';
import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { getTimeFormat } from '../../../helpers/dates';
import { getLocale } from '../../../helpers/locales';
import useTranslate from '../../../hooks/useTranslate';
import * as Styled from './styled';

const CalendarSubmit = ({ selectedDate, onSubmitDate, t }) => {
  const { i18n } = useTranslate();
  const [locale, setLocale] = useState(undefined);

  useEffect(() => {
    getLocale(i18n.language).then((l) => {
      setLocale(l.default);
    });
  }, [i18n.language]);

  const { convertToAmPmTime, lang } = window.Widget.settings;
  const parsedDate = new Date(selectedDate).getFullYear();
  const currentYear = getYear(startOfToday());
  const eventYear = getYear(parsedDate);
  const year = currentYear === eventYear ? '' : ' yyyy';
  const timeFormat = getTimeFormat(convertToAmPmTime, lang);

  return (
    <Styled.Submit onClick={onSubmitDate}>
      {t('select')} {format(selectedDate, `dd MMMM ${year} ${timeFormat}`, { locale })}
    </Styled.Submit>
  );
};

// @ts-ignore
export default withTranslation()(CalendarSubmit) as any;
